import { BASE_URL } from "@/utils/apiBaseUrl";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const adminSignIn = createAsyncThunk(
  "adminSignIn",
  async (loginData, { rejectWithValue }) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/login`, loginData, config);
      // store user's token in cookies
      data.data.token &&
        cookies.set("userToken", data.data.token, { path: "/" });
      return data;
    } catch (error) {
      // return custom error message from API if any
      if (
        error.response && error.response.data.message
          ? error.response.data.message
          : error.response.data.error
      ) {
        return rejectWithValue(
          error.response.data.message
            ? error.response.data.message
            : error.response.data.error
        );
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const userToken = cookies.get("userToken") ? cookies.get("userToken") : null;

const initialState = {
  loading: false,
  userToken,
  error: null,
  success: false,
};

const adminLoginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      cookies.remove("userToken", { path: "/" });
      // localStorage.clear();
      state.loading = false;
      state.userToken = null;
      // state.userInfo = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // login user
    builder.addCase(adminSignIn.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(adminSignIn.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.userToken = payload.data.token;
    });
    builder.addCase(adminSignIn.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    });
  },
});
export const { logout } = adminLoginSlice.actions;
export default adminLoginSlice.reducer;
